import React, { useRef, useEffect, useState ,useContext} from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import CommonStyle from "../Styles/Common.module.css";
import FontStyle from "../Styles/FontStyle.module.css";
import ButtonStyle from "../Styles/Button.module.css";
import { Link, useParams, useNavigate } from "react-router-dom";
import Search from "./Search";
import { LuSearch } from "react-icons/lu";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { IMAGE_BASE_URL, API_BASE_URL } from "./../../constants";
import AuthContext from "../../store/auth-context";
import axios from "axios";
import LocationCover from '../Browse/LocationCover';
import {IoIosArrowBack,IoIosArrowForward,} from "react-icons/io";
import { PostSearchDetails,PostSearchFilter,SendPropertRequest} from "../../services/routes.services";
import { Map, InfoWindow, Marker, GoogleApiWrapper, Listing } from 'google-maps-react';
import { Helmet } from "react-helmet";

import LoginScreen from "../Auth/Login/Login";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';
import { Spinners } from "../Common/Common/Loader";

const responsiveMain = {
  desktop: { breakpoint: { max: 3000, min: 1024 }, items: 1 },
  tablet: { breakpoint: { max: 1024, min: 464 }, items: 1 },
  mobile: { breakpoint: { max: 464, min: 0 }, items: 1 }
};

const responsiveDots = {
  all: { breakpoint: { max: 4000, min: 0 }, items: 5 }
};

const SearchResult = (props) => {
  // new Edit
  const [isCheckRequest, setIsCheckRequest] = useState({})
  const [requestMsg, setRequestMsg] = useState();
  const authCtx = useContext(AuthContext);
  const [spinner, setSpinner] = useState(false);
  const navigate = useNavigate();
  const [hoveredCarousel, setHoveredCarousel] = useState({});
const [activeSlides, setActiveSlides] = useState({});
  const mainCarouselRefs = useRef({});
  const dotCarouselRefs = useRef({});
  // const simplePro = useRef(null);
  // const moveHandler = ()=>{
  //   simplePro.current?.scrollIntoView({behavior: "smooth"})
  // }
  const handleDotClick = (locationId, index) => {
    if (mainCarouselRefs.current[locationId]) {
      mainCarouselRefs.current[locationId].goToSlide(index);
      setActiveSlides((prev) => ({
        ...prev,
        [locationId]: index
      }));
    }
  };



  console.log(authCtx)
  const requestCheckHandler =(e, id)=>{
    setIsCheckRequest((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };
  const handleSubmit = async () => {
    setSpinner(true)
    const selectedIds = Object.keys(isCheckRequest).filter((id) => isCheckRequest[id]);
  
    if (selectedIds.length === 0) return;
  
    const postData = {
      property_id: selectedIds.join(","),
    };
  
    if (authCtx.token) {
      try {
        const response = await SendPropertRequest(postData, authCtx.token);
        setSpinner(false)
        toast.success("Request sent successfully!");
        setIsCheckRequest(false);
        console.log("Request successful:", response.data);
      } catch (error) {
        setSpinner(false)
        toast.error("Failed to send request. Please try again.");
        console.error("Request failed:", error.response?.data || error.message);
      }
    } else {
      setSpinner(false)
      setShowLoginPopup(true);
    }
  };
  
  const handleLogoutClick = () => {
    authCtx.logout();
    navigate('/searchResult');
  };
  
  
  
  const isAnyChecked = Object.values(isCheckRequest).some(Boolean);
  // new Edit

  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const [searchResultValue, setSearchResultValue] = useState();
  const [searchCityValue, setSearchCityValue] = useState();
  const [checkedMap, setCheckedMap] = React.useState(true);
  const [link, setLink] = useState(false);
  const [PaginationList, setPaginationList] = useState([]);
  const [propertyType, setPropertyType] = useState("");
  const [filterCategoryArray, setFilterCategoryArray] = useState([]);
  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
  const [searchBox, setSearchBox ] = useState(false);

  const showSearchHandler = ()=>{
    setSearchBox(true)
  }
  const closeSearchHandler = ()=>{
    setSearchBox(false)
  }
  
  //Get Location Data
  const ActivityValue= localStorage.getItem("SearchActivity");
  const locationValue = localStorage.getItem("SearchLocation");
  const crewValue = localStorage.getItem("SearchCategory");
  const shootValue = localStorage.getItem("SearchActivityDay");
  //
  
  useEffect(() => {
    PostSearchDeatil();
  }, [localStorage.getItem("SearchLocation"),crewValue,shootValue]);

const PostSearchDeatil =()=>{
  var Categrory=crewValue;
  if(crewValue==='null'){
    Categrory='';
  }
  const postData = {
    //search_for :ActivityValue,
    location: locationValue,
    category: Categrory,
    };

  PostSearchDetails(postData,authCtx.token).then((response) => {
      setSelectedCheckboxes([]);
      setFilterCategoryArray([]);
      localStorage.setItem("setAminitiesSearch", []);
      localStorage.setItem("setCategoryFilterSearch", []);
      localStorage.setItem("setLocationNameSearch", response.data.city.title);
      localStorage.setItem("setPropertyTypeFilter", '');
      setSearchResultValue(response.data);
      setPaginationList(response.data.data);
      setSearchCityValue(localStorage.getItem("setLocationNameSearch"));
    })
    .catch((error) => {
      console.log(error);
    });
}


  //Login Detail
  const handleCloseLoginPopup = () => {
    setShowLoginPopup(false);
  };
  const handleLoginClick = () => {
    setShowLoginPopup(true);
  };
//Login Detail end



  const handleCallback = (data) => {
    setSearchResultValue(data);
    
  };

  const Navigate = useNavigate();
  const smoothScroll = (URL, id) => {
    Navigate({
      pathname: URL,
      search: "?property-detail=" + id,
    });
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

///console.log(propertyType)
  const SearchFilter = (pageNumber,id,category,protype) => {
    let AminiId='';
    let CategoryId='';
    if(localStorage.getItem("SearchCategory")!=='null' && category.length === 2){
    if(category.length === 2){
      if (filterCategoryArray.includes( localStorage.getItem("SearchCategory"))) {
          setFilterCategoryArray(filterCategoryArray.filter(item => item !==  localStorage.getItem("SearchCategory")));
        } else {
          setFilterCategoryArray([...filterCategoryArray,  localStorage.getItem("SearchCategory")]);
        }
      CategoryId=[...filterCategoryArray,  localStorage.getItem("SearchCategory")]
      localStorage.setItem("setCategoryFilterSearch",CategoryId)
    }
  }

  if(id!=undefined || category!=undefined){
    if(id!=''){
      AminiId=JSON.parse(id)
    }
    if(category!=''){
      CategoryId=JSON.parse(category)
    }  
  }

  const postData = {
    location: locationValue,
    // crew: crewValue,
    // days: shootValue,
    property_type: protype,
    page: pageNumber,
    amenities:AminiId,
    category:CategoryId,
  };

    PostSearchFilter(postData)
      .then((response) => {
        setSearchResultValue(response.data);
       
        setPaginationList(response.data.data);
        //GetcityCoordinates();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  let TotalNum = "";
  let CityName = searchCityValue;
 
  if (searchResultValue != undefined) {
    TotalNum = searchResultValue.data.total;
    CityName = localStorage.getItem("setLocationNameSearch");
  }
  
 const handlePagination = (url) => {
      if(url!=null){
        const Url_array = url.split("=");
        let setAminitiesSearch=localStorage.getItem("setAminitiesSearch");
        let setCategoryFilterSearch=localStorage.getItem("setCategoryFilterSearch");
        let setPropertyTypeFilter=localStorage.getItem("setPropertyTypeFilter");
        SearchFilter(Url_array[1],setAminitiesSearch,setCategoryFilterSearch,setPropertyTypeFilter);
      }
  };
  
  useEffect(()=>{
    if(filterCategoryArray.length>0 || selectedCheckboxes.length>0){
      localStorage.setItem("setAminitiesSearch", JSON.stringify(selectedCheckboxes));
      localStorage.setItem("setCategoryFilterSearch", JSON.stringify(filterCategoryArray));
      let setAminitiesSearch=localStorage.getItem("setAminitiesSearch");
      let setCategoryFilterSearch=localStorage.getItem("setCategoryFilterSearch");
      let setPropertyTypeFilter=localStorage.getItem("setPropertyTypeFilter");
        SearchFilter("",setAminitiesSearch,setCategoryFilterSearch,setPropertyTypeFilter)
    }
  },[selectedCheckboxes,filterCategoryArray,propertyType])

  useEffect(()=>{
    if(filterCategoryArray.length==0 && selectedCheckboxes.length ==0){ 
      PostSearchDeatil()
    }
  },[filterCategoryArray.length==0,propertyType,selectedCheckboxes.length ==0])

  const [latstateName, setLatStateName] =useState([]);
  const [lngstateName, setLngStateName] =useState([]);
  const [map, setMap]= useState(null)
  var mapCityName = CityName != undefined && CityName;
  const google = window.google;
  if(CityName !== mapCityName){}
useEffect(() => {
  var geocoder =  new google.maps.Geocoder();
  geocoder.geocode( { address: mapCityName }, function(results, status) {
        if (status == google.maps.GeocoderStatus.OK) { 
          setLatStateName(results[0].geometry.location.lat())
          setLngStateName(results[0].geometry.location.lng()) 
          return
        }
      });
}, [mapCityName]);
const cityValur = [{lat:latstateName, lng:lngstateName}]

  return (
    <div className={CommonStyle.searchResultPage + " " + CommonStyle.headerSpace} id="homeSection">
     <Helmet>      
        <title>{CityName}</title>
         <meta name="title" content={CityName} />
    </Helmet>
      <div className={CommonStyle.breadCrumb}>
        <Container>
          <Row>
            <Col className={CommonStyle.ulFlex}>
              <ul>
                <li><Link to="/" onClick={smoothScroll}>Home</Link></li>
                <li>Search Results</li>
              </ul>
              {authCtx.isLoggedIn && <Link to="#" onClick={(e) => {e.preventDefault();handleLogoutClick();}} title='Logout'>Logout</Link>}
            </Col>
          </Row>
        </Container>
      </div>
      {/* <div className={CommonStyle.areaAvabel}>
        <LocationSlider />
      </div> */}
      <div className={CommonStyle.SearchFilter}>
        <Container>
          <Row>
            <Col>
              <div className={CommonStyle.responsiveView + ' ' + CommonStyle.tabSearch}>
                <button type="button" onClick={showSearchHandler} className={ ButtonStyle.defaultButton + " " + CommonStyle.tabSearchButton}>
                      Search Now <LuSearch className={ButtonStyle.buttonArrow} />
                </button>
              </div>
              {searchBox && 
                <div className={CommonStyle.searchOverLay}>
                  <div className={CommonStyle.tabSerachContainer}>
                    <button type='button' onClick={closeSearchHandler} className={CommonStyle.closeSearch}><svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none"><path d="M25.1111 10.8889L10.8889 25.1111M10.8889 10.8889L25.1111 25.1111M34 18C34 26.8366 26.8366 34 18 34C9.16345 34 2 26.8366 2 18C2 9.16345 9.16345 2 18 2C26.8366 2 34 9.16345 34 18Z" stroke="white" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round"/></svg></button>
                    <Search parentCallback={handleCallback} closeSearch={closeSearchHandler}  />
                  </div>
                </div> 
              }
              <div className={CommonStyle.searchBrownBg + ' ' + CommonStyle.desktopView}>
                <Search parentCallback={handleCallback} />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <div className={CommonStyle.searchresultArea}>
        <Container>
        <Row>
          <Col>
              <div className={CommonStyle.sendFlex}>
                  <h2 className={CommonStyle.FlexCol + ' ' + FontStyle.Axiforma300 + ' ' + FontStyle.BlackColor}> 
                  Search <span className={FontStyle.Axiforma800 + ' ' + FontStyle.OrangeColor}>Results</span>
                  </h2>
                  <div>
                    <button type="button" disabled={!isAnyChecked} onClick={handleSubmit} className={ButtonStyle.largeButton + ' ' + ButtonStyle.roundStyle + ' ' + ButtonStyle.orangeStyle}>Request Detail Info Of Property</button>
                    {authCtx.token===null ? 
                      <button type="button" onClick={handleLoginClick} className={ButtonStyle.largeButton + ' ' + ButtonStyle.roundStyle + ' ' + ButtonStyle.orangeStyle}>Login</button>
                      :
                      <Link to='/dashboard' className={ButtonStyle.largeButton + ' ' + ButtonStyle.roundStyle + ' ' + ButtonStyle.orangeStyle}>Dashboard</Link>
                      
                    }
                  </div>
              </div>
              <h6>{requestMsg}</h6>
          </Col>
        </Row>
            <Row>
              <Col>
                <div className={CommonStyle.serachListing}>
                  <Row className="filterColumOrder">
                    <h4 className="cheeckText">Select properties that suit your requirement to receive full information. To view sample information 
                      <Link to="/#sampleProperty"> click here.</Link></h4>
                    <Col className={checkedMap ? "col" : "col "}>
                      <div className={CommonStyle.locationResult}>
                        {searchResultValue != undefined ? (
                          <>
                            {searchResultValue?.data?.data.map((LocationDetail) => {
                              const currentActiveSlide = activeSlides[LocationDetail.id] || 0;
                              return (
                                <div className={CommonStyle.width25} key={LocationDetail.id}>
                                  <div className={"areaImgSlider " + CommonStyle.areaImgBox} 
                                    onMouseEnter={() => setHoveredCarousel((prev) => ({ ...prev, [LocationDetail.id]: true }))}
                                    onMouseMove={() => setHoveredCarousel((prev) => ({ ...prev, [LocationDetail.id]: true }))}
                                    onMouseLeave={() => setHoveredCarousel((prev) => ({ ...prev, [LocationDetail.id]: false }))}
                                  >
                                    <div className={CommonStyle.sliderContainer}>
                                      <Carousel
                                        ref={(el) => (mainCarouselRefs.current[LocationDetail.id] = el)}
                                        responsive={responsiveMain}
                                        arrows={true}
                                        infinite={false}
                                        showDots={false}
                                        afterChange={(_, state) => {
                                          const realIndex = state.currentSlide % LocationDetail.media.length;
                                          setActiveSlides((prev) => ({
                                            ...prev,
                                            [LocationDetail.id]: realIndex,
                                          }));

                                          if (dotCarouselRefs.current[LocationDetail.id]) {
                                            const dotSlider = dotCarouselRefs.current[LocationDetail.id];
                                            const visibleItems = 5;
                                            const middleDot = Math.max(realIndex - Math.floor(visibleItems / 2), 0);
                                            dotSlider.goToSlide(middleDot);
                                          }
                                        }}
                                        autoPlay={!!hoveredCarousel[LocationDetail.id]}
                                        autoPlaySpeed={1000} 
                                        pauseOnHove
                                        swipeable
                                        draggable
                                        slidesToSlide={1}
                                        keyBoardControl
                                      >
                                        {LocationDetail.media.map((LocImage) => (
                                          <div className={CommonStyle.item} key={LocImage.id}>
                                            <Link to={`/property-detail/${LocationDetail.location_code}`}>
                                              <img src={`${IMAGE_BASE_URL}/property/size/${LocImage.image}`} alt="" />
                                            </Link>
                                          </div>
                                        ))}
                                      </Carousel>
                                      <div className={CommonStyle.linkPost}>
                                        <div className={CommonStyle.filterList}>
                                          <label>
                                            {/* <p>Request For</p> */}
                                            <input type="checkbox" checked={!!isCheckRequest[LocationDetail.id]} onChange={(e) => requestCheckHandler(e, LocationDetail.id)} />
                                            <span className={CommonStyle.checkmark}></span>
                                          </label>
                                        </div>
                                      </div>
                                      {/* Dot Carousel */}
                                      <div className={CommonStyle.sliderDots}>
                                        <Carousel
                                          ref={(el) => (dotCarouselRefs.current[LocationDetail.id] = el)}
                                          responsive={responsiveDots}
                                          arrows={true}
                                          infinite={false}
                                          swipeable
                                          draggable
                                          showDots={false}
                                          keyBoardControl
                                          itemClass="dot-carousel-item"
                                        >
                                          {LocationDetail.media.map((_, index) => (
                                            <div
                                              key={index}
                                              onClick={() => handleDotClick(LocationDetail.id, index)}
                                              className={currentActiveSlide === index ? CommonStyle.customDot + ' ' + CommonStyle.active : CommonStyle.customDot}
                                            />
                                          ))}
                                        </Carousel>
                                      </div>
                                    </div>
                                  </div>
                                  <div className={CommonStyle.areaDetail}>
                                    <h6 className={FontStyle.Axiforma600}><Link to={`/property-detail/${LocationDetail.location_code}`}>{LocationDetail.location_code}</Link></h6>
                                  </div>
                                </div>
                              );
                            })}
                          </>
                        ) : null}
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          <>
          {TotalNum!==0?(
          <Row>
            {PaginationList != undefined ? (
              <Col>
                <div className={CommonStyle.pagination}>
                  <ul>
                    <li className={CommonStyle.paggingArrow}>
                      <a
                        onClick={() =>
                          handlePagination(PaginationList.prev_page_url)
                        }
                      >
                        <IoIosArrowBack />
                      </a>
                    </li>

                    {PaginationList.links != undefined ? (
                      <>
                        {PaginationList.links.map((Pagnum) => {
                          return (
                            <span key={Pagnum.label}>
                              {" "}
                              {Pagnum.label != "&laquo; Previous" &&
                              Pagnum.label != "Next &raquo;" ? (
                                <li
                                  className={
                                    Pagnum.active === true
                                      ? CommonStyle.active
                                      : null
                                  }
                                  key={Pagnum.label}
                                >
                                  <a style={{cursor: "pointer"}}
                                    onClick={() => handlePagination(Pagnum.url)}
                                  >
                                    {Pagnum.label}
                                  </a>
                                </li>
                              ) : (
                                ""
                              )}
                            </span>
                          );
                        })}
                      </>
                    ) : null}
                    <li className={CommonStyle.paggingArrow}>
                      <a
                        onClick={() =>
                          handlePagination(PaginationList.next_page_url)
                        }
                      >
                        <IoIosArrowForward />
                      </a>
                    </li>
                  </ul>
                </div>
              </Col>
            ) : null}
          </Row>):null}
          </>
          <Row>
            <Col>
              <div className={CommonStyle.cityArea}>
                <LocationCover/>
                <p>
                  Join our email list and be the first to know when we add new
                  spaces.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <ToastContainer
  position="top-right"
  autoClose={3000}
  hideProgressBar={false}
  newestOnTop={false}
  closeOnClick
  pauseOnFocusLoss
  draggable
  pauseOnHover
/>
      {showLoginPopup && <LoginScreen onClose={handleCloseLoginPopup} pageName={"SearchResult"}/>}
      {spinner && <Spinners /> }
    </div>
  );
};

export default GoogleApiWrapper({
  apiKey:('AIzaSyBCDCl9itJWlR2_DcxEFLDstCJfMhqMZvE')
})(SearchResult);
